import { render, staticRenderFns } from "./wx-low-version.vue?vue&type=template&id=04cc68e8&"
var script = {}
import style0 from "./wx-low-version.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports